import * as React from 'react';
import { Link } from 'shared/components/Link';
import b_ from 'b_';

import './index.scss';

interface Props {
  to: string;
  children: React.ReactElement<any> | string;
}

const b = b_.with('footer-link');

const FooterLink: React.FC<Props> = ({ to, children }) => {
  if (to.match(/^mailto:/)) {
    return (
      <a className={b({ email: true })} href={to}>
        {children}
      </a>
    );
  }

  if (!to.startsWith('/investments')) {
    return (
      <a className={b()} href={to} target={to.startsWith('http') ? '_blank' : '_self'}>
        {children}
      </a>
    );
  }

  return (
    <Link className={b()} to={to}>
      {children}
    </Link>
  );
};

export default FooterLink;
